import { type FC } from 'react';
import type { GroupedCustomization } from './customizationGrouping';
import type { ControlType } from './controlTypes';
import type { ControlProps, GroupControlProps, CustomizationUpdater } from './props';
import { EnumValueType } from '@Model';

// controls
import { OffsetControl } from './GroupControls';
import { FileInputControl, HtmlEditorControl, NumberInputControl, TextInputControl } from './Controls';

const groupControlToComponentMap: Record<ControlType, FC<GroupControlProps>> = {
    offset: OffsetControl,
};

const controlToComponentMap: Partial<Record<EnumValueType, FC<ControlProps>>> = {
    [EnumValueType.Html]: HtmlEditorControl,
    [EnumValueType.File]: FileInputControl,
    [EnumValueType.Integer]: NumberInputControl,
    [EnumValueType.Float]: NumberInputControl,
    [EnumValueType.Link]: TextInputControl,
    [EnumValueType.PlainText]: TextInputControl,
};

interface CustomizationProps {
    data: GroupedCustomization;
    locked?: boolean;
    updateData: CustomizationUpdater;
}

export const Customization: FC<CustomizationProps> = ({ data, locked, updateData }) => {
    if ('control' in data) {
        const Control = groupControlToComponentMap[data.control];
        // No check if Control is undefined => has to break
        return <Control data={data} locked={locked} updateData={updateData} />;
    }

    const Control = controlToComponentMap[data.type]!;
    // No check if Control is undefined => has to break
    return <Control data={data} locked={locked} updateData={updateData} />;
};
